import { callDeepLink, compareWithAppVersion } from '@croquiscom/web2app';
import orderBy from 'lodash/orderBy';

import { LatestAppVersionPopup, usePopupDialog } from '@common/overlay-manager';
import { SummaryCardServiceProps } from '@common/review';
import { numberWithPlusSignByMaxCount } from '@common/utils';
import { useCheckExternalReviewQuery, useReviewListConfig, useReviewListUrl } from '@domains/review-list-common';

import { SummaryCardProps } from '../component/SummaryCard';
export function useSummaryCardService({ ux_review_list, related_product_review_summary }: SummaryCardServiceProps) {
  const { open } = usePopupDialog();

  const { catalog_product_id, replaceReviewTab, isZigzagApp = false, path } = useReviewListConfig();

  const { is_exposed } = useCheckExternalReviewQuery(catalog_product_id);
  const reveiwListUrl = useReviewListUrl({ product_id: catalog_product_id });
  const originReviewCount = is_exposed
    ? (related_product_review_summary?.all_count_external_included ?? related_product_review_summary?.all_count ?? 0)
    : (related_product_review_summary?.all_count ?? 0);
  const totalCount = numberWithPlusSignByMaxCount(originReviewCount, 99999);

  const review_list: (SummaryCardProps & { id: string; type: 'video' | 'photo' })[] =
    ux_review_list?.item_list
      .filter((value) => value.video_list.length > 0 || value.image_list.length > 0)
      .map((item) => ({
        contents: item.contents,
        thumbnail: item.video_list[0]?.thumbnail_url ?? item.image_list[0]?.thumbnail_url,
        id: item.id,
        isReported: item.requested_user?.is_abuse_reported ?? false,
        type: item.video_list.length > 0 ? 'video' : 'photo',
      })) ?? [];

  const sortedReviewList = orderBy(review_list, ['isReported'], ['asc']);

  const ratings_average = related_product_review_summary?.ratings_average ?? 0;

  const show_summary_section = sortedReviewList.length > 0 && ratings_average > 3;
  const first_attribute = related_product_review_summary?.attribute_list?.[0];
  const summary_text = first_attribute?.most_answer?.label;
  const summary_percent = first_attribute?.most_answer?.percent;
  const summary_label = first_attribute?.question?.category;
  const show_summary_comment = Number(summary_percent) >= 80;

  const openPhotoReviewInApp = (review_id: string) => {
    if (!compareWithAppVersion('7.23.0')) {
      open(LatestAppVersionPopup());
      return;
    }

    callDeepLink(path.review.list(review_id))();
  };

  const service = {
    isZigzagApp,
    show_summary_section,
    totalCount,
    show_more_item: isZigzagApp ? false : originReviewCount > 5,
    ratings_average,
    summary: {
      text: summary_text,
      percent: summary_percent,
      label: summary_label,
    },
    show_summary_comment,
    review_list: sortedReviewList,
    handleViewMoreFromTab: replaceReviewTab,
    reveiwListUrl,
    openPhotoReviewInApp,
  };

  return service;
}
